import vana_logo_default from "../../../assets/vana-logo.js";
import vana_card_logo_default from "../../../assets/vana-card-logo.js";
import vana_card_blue_default from "../../../assets/vana-card-blue.js";
import vana_card_blue_dark_default from "../../../assets/vana-card-blue-dark.js";
import vana_square_logo_default from "../../../assets/vana-square-logo.js";
import { LogoType } from "../../../domain/logo/logo.js";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/utils/logo.tsx
var LOGO_CONFIG = {
	[LogoType.Vana]: {
		src: vana_logo_default,
		defaultAlt: LogoType.Vana
	},
	[LogoType.VanaCard]: {
		src: vana_card_logo_default,
		defaultAlt: LogoType.VanaCard
	},
	[LogoType.VanaCardBlue]: {
		src: vana_card_blue_default,
		defaultAlt: LogoType.VanaCardBlue
	},
	[LogoType.VanaCardBlueDark]: {
		src: vana_card_blue_dark_default,
		defaultAlt: LogoType.VanaCardBlueDark
	},
	[LogoType.VanaSquare]: {
		src: vana_square_logo_default,
		defaultAlt: LogoType.VanaSquare
	}
};
var Logo = ({ type = LogoType.Vana, alt, className } = {}) => {
	const config = LOGO_CONFIG[type];
	return /* @__PURE__ */ jsx("img", {
		src: String(config.src),
		alt: alt || config.defaultAlt,
		className
	});
};
var VanaCardLogo = ({ alt, className } = {}) => /* @__PURE__ */ jsx(Logo, {
	type: LogoType.VanaCard,
	alt,
	className
});
//#endregion
export { Logo, VanaCardLogo };

//# sourceMappingURL=logo.js.map